/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AdditionalCostDtoFromJSON(json) {
    return AdditionalCostDtoFromJSONTyped(json, false);
}
export function AdditionalCostDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fuel': !exists(json, 'fuel') ? undefined : json['fuel'],
        'clean': !exists(json, 'clean') ? undefined : json['clean'],
        'other': !exists(json, 'other') ? undefined : json['other'],
    };
}
export function AdditionalCostDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fuel': value.fuel,
        'clean': value.clean,
        'other': value.other,
    };
}
